import React, { lazy, Suspense, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import GuestRoute from './GuestRoute';
import ProtectedRoute from '../components/ProtectedRoute';
import RouteBoundary from './RouteBoundary';
import { developmentAddress } from './navigation';
import { chapterBackground } from './chapterNavigation';

const Home = lazy(() => import('../OptionsHome'));
const ChapterModal = lazy(() => import('../components/ChapterModal'));
const ChapterDirectory = lazy(() => import('../components/ChapterDirectory'));
const SignIn = lazy(() => import('../components/SignIn'));
const SignInEmail = lazy(() => import('../components/SignInEmail'));
const SignUp = lazy(() => import('../components/SignUp'));
const SignInLink = lazy(() => import('../components/SignInMagicLink'));
const ForgotPassword = lazy(() => import('../components/ForgotPassword'));
const FinishLogin = lazy(() => import('../components/FinishLogin'));
const EmailSent = lazy(() => import('../components/MagicLinkWait'));
const Account = lazy(() => import('../components/Account'));
const Pricing = lazy(() => import('../components/PurchasePage'));
const Consulting = lazy(() => import('../components/Consulting'));
const CheckoutReturn = lazy(() => import('../components/CheckoutReturn'));
const Lessons = lazy(() => import('./LessonRoutes'));
const RoadMap = lazy(() => import('!babel-loader!@mdx-js/loader!../pages_posts/posts/RoadMap.mdx'));
const Seagull = lazy(() => import('!babel-loader!@mdx-js/loader!../pages_posts/posts/Seagull_Setup.mdx'));
const Optimization = lazy(() => import('!babel-loader!@mdx-js/loader!../pages_posts/posts/OptimizationBox.mdx'));
const Strangle = lazy(() => import('!babel-loader!@mdx-js/loader!../pages_posts/posts/STRANGLE_ROLLING.mdx'));
const Story = lazy(() => import('./PublicPages').then(pages => ({ default: pages.Story })));
const Crisis = lazy(() => import('./PublicPages').then(pages => ({ default: pages.Crisis })));
const CoveredCall = lazy(() => import('./PublicPages').then(pages => ({ default: pages.CoveredCall })));
const Poisson = lazy(() => import('./PublicPages').then(pages => ({ default: pages.Poisson })));
const VerticalStory = lazy(() => import('./PublicPages').then(pages => ({ default: pages.VerticalStory })));
const Insights = lazy(() => import('./PublicPages').then(pages => ({ default: pages.Insights })));

const authRoutes = [['/signin', SignIn], ['/signinemail', SignInEmail], ['/signup', SignUp], ['/signinLink', SignInLink]];
const publicRoutes = [
  ['/', Home], ['/chapters', ChapterDirectory], ['/consulting', Consulting], ['/pricing', Pricing], ['/purchase-success', CheckoutReturn], ['/purchase-cancelled', CheckoutReturn], ['/forgotPassword', ForgotPassword], ['/finishLogin', FinishLogin], ['/wait', EmailSent],
  ['/roadmap', RoadMap], ['/strangle_rollup_open', Strangle], ['/interactive_story', Story], ['/fin_crisis', Crisis],
  ['/cov_call', CoveredCall], ['/poisson', Poisson], ['/interactive_story_vertical', VerticalStory], ['/fetch_insights', Insights],
];
const aliases = [['/login', '/signin'], ['/register', '/signup'], ['/signin/google', '/signin'], ['/signin/email', '/signinemail'], ['/signin/link', '/signinLink'], ['/forgot-password', '/forgotPassword']];

export default function AppRoutes() {
  const location = useLocation();
  const background = chapterBackground(location);
  const canonical = developmentAddress(window.location.href, process.env.NODE_ENV);
  useEffect(() => { if (canonical) window.location.replace(canonical); }, [canonical]);
  if (canonical) return <p role="status">Opening the local preview…</p>;
  return <RouteBoundary key={(background || location).pathname}><div style={{ isolation: 'isolate' }}><Suspense fallback={<p role="status" style={{ padding: 32 }}>Loading page…</p>}>
    <Switch location={background || location}>
      {authRoutes.map(([path, Component]) => <GuestRoute key={path} exact path={path} component={Component} />)}
      {publicRoutes.map(([path, Component]) => <Route key={path} exact path={path} component={Component} />)}
      {aliases.map(([path, destination]) => <Route key={path} exact path={path} render={() => <Redirect to={{ pathname: destination, search: location.search, hash: location.hash, state: location.state }} />} />)}
      <ProtectedRoute exact path="/account" access="signedIn" component={Account} />
      <ProtectedRoute exact path="/PutCollarSpread" access="signedIn" component={Seagull} />
      <ProtectedRoute exact path="/optimization" access="signedIn" component={Optimization} />
      <Route exact path="/taxes" render={() => <h1>Taxes</h1>} />
      <Route exact path="/loans" render={() => <h1>Loans</h1>} />
      <Route component={Lessons} />
    </Switch>
  </Suspense></div>
    {background && <RouteBoundary key={location.pathname}><Suspense fallback={<p role="status">Opening chapter…</p>}><ChapterModal /></Suspense></RouteBoundary>}
  </RouteBoundary>;
}
